<template>
    <div style="background:#fff; margin-left:3px; "> 
        <el-table :data="tmpData" 
            border                            
            disabled-hover
            style="overflow:auto;margin-top:1px;"
            size="small"
            ref="reftab"
            header-cell-class-name="clearPadding"
 
            class="custom-table-border"
            :cell-style="{padding:'2px',color:'black','font-size':'12px',}"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            :min-height="120" 
            highlight-current-row >
            <el-table-column label="序号" type="index" width="45" fixed> </el-table-column>
            <el-table-column   v-for="(item ,index) in tabCol.filter(item=>item.thide=='N' )" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="false"
                :min-width="item.width">
                    <template slot-scope="scope">
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" :disabled="item.key!=='SEL'" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]"></span>
                    </template>
            </el-table-column>              
        </el-table>
 
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>
import {  getBaseData } from '../../api/user' 
 
export default {
    props: {
        v_key2:{
            type: String,
            default:'',
        } ,
        v_value2:{
            type: String,
            default:'',
        },
        v_table:{
            type: String,
        },
        tabCol:{
            type: Array,
        },
        v_cond:{
            type: String,
            default:'',
        },
        v_key:{
            type: String,
            default:'',
        } ,
        v_value:{
            type: String,
            default:'',
        },
    },
    data () {
        return {
            oper:'like',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            txtparam:'', // input 绑定值
            dataCount:0,
            tmpData:[] ,// 
 
            disabled:false,
            empRow:{},
 
            promptWin:false,
            prompt:'',
 
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            current:1,
            v_sel:'N',
            v_loading:false,
            v_row:{},
        }
    },
    created () {
 
    },
    watch: {
        v_table:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
        } ,
        v_value2:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
        } ,
        v_cond:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData() 
        } ,
        v_value:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
        } ,
 
    },
    mounted () {   
        this.qryTabData()
    },
    computed: {
 
    },
    methods: { 
        //查询表格数据
        qryTabData(){
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:this.v_key2,p_value2:this.v_value2,p_key3:this.v_key,p_value3:this.v_value, p_table: this.v_table},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tmpData =res.result
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs['reftab'].doLayout()
                        this.v_loading=false
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }    
            })      
        },
    }
}
 
</script>
<style scoped lang="less" >
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
